<orbit-dialog-header [title]="'SHARED.DIALOGS.EDIT_PARTICIPANT_DIALOG.TITLE' | translate" />

<div class="edit-participant-dialog">
  <div class="dialog-content">
    <form [formGroup]="editParticipantForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <orbit-form-field
          type="text"
          id="displayName"
          [label]="'SHARED.DIALOGS.EDIT_PARTICIPANT_DIALOG.DISPLAY_NAME' | translate"
          [controller]="displayName"
          placeholder="{{
            'SHARED.DIALOGS.EDIT_PARTICIPANT_DIALOG.DISPLAY_NAME_PLACEHOLDER' | translate
          }}" />
      </div>

      @if (role() === participantKindEnum.Client) {
        <div class="form-group">
          <orbit-form-field
            type="tel"
            id="phone"
            [controller]="phoneNumber"
            [label]="'SHARED.DIALOGS.EDIT_PARTICIPANT_DIALOG.PHONE' | translate"
            [errorMessage]="'SHARED.CREATE_CONVERSATION_FORM.PHONE_ERROR_MESSAGE' | translate"
            placeholder="{{
              'SHARED.DIALOGS.EDIT_PARTICIPANT_DIALOG.PHONE_PLACEHOLDER' | translate
            }}" />
        </div>
      }

      @if (role() === participantKindEnum.Client) {
        <div class="form-group">
          <orbit-form-field
            type="email"
            id="email"
            [label]="'SHARED.DIALOGS.EDIT_PARTICIPANT_DIALOG.EMAIL' | translate"
            [controller]="email"
            placeholder="{{
              'SHARED.DIALOGS.EDIT_PARTICIPANT_DIALOG.EMAIL_PLACEHOLDER' | translate
            }}" />
        </div>
        <div class="form-group">
          <orbit-form-field
            id="preferredLanguage"
            [inputType]="'select'"
            [label]="'SHARED.DIALOGS.EDIT_PARTICIPANT_DIALOG.PREFERRED_LANGUAGE' | translate"
            [controller]="preferredLanguage"
            [selectOptions]="availableLanguages" />
        </div>
      }

      @let _errors = errors();
      <div class="error-wrapper">
        @for (error of _errors; track error.id) {
          <orbit-message [message]="error.message ?? error.code | translate" [severity]="'error'" />
        }
      </div>
    </form>
  </div>

  <orbit-dialog-footer>
    <div class="right-addon" right-addon>
      <orbit-button
        [flat]="true"
        [label]="'SHARED.DIALOGS.CONFIRM_DIALOG.CANCEL_LABEL' | translate"
        (click)="onCancel()"
        (keydown)="onCancelKeyDown($event)" />
      <orbit-button
        [disabled]="editParticipantForm.invalid || isSubmitting()"
        [label]="'SHARED.DIALOGS.CONFIRM_DIALOG.CONFIRM_LABEL' | translate"
        (buttonClick)="onSubmit()" />
    </div>
  </orbit-dialog-footer>
</div>
